
// Add the path and toMatrix functions to lodash
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define('lodashPath',['underscore'], factory);
    } else {
        factory(_);
    }
})(function (_) {
    var opts = {
        refProp: '$ref',
        idProp: '$id',
        clone: true
    };

    _.mixin({
        path: function (obj, path, def) {

            var getProperty = function (item) {
                _(path.split('.')).each(function (prop) {
                    if (!item || typeof item !== 'object') return def;
                    item = item[prop];
                });
                if (item === undefined) return def;
                return item;
            }
            if (_(obj).isArray())
                return _(obj).map(getProperty).value();
            else
                return getProperty(obj, path, def);
        },
        toMatrix: function (arr, take) {
            return _(arr).groupBy(function (a, b) {
                return Math.floor(b / take);
            }).toArray().value();
        }
    });
});